export default "__VITE_ASSET__2426f9ed__"